export const PASSWORD_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export type PasswordStrength = 'empty' | 'weak' | 'medium' | 'good' | 'strong';

export type PasswordFailureKey =
  | 'tooShort'
  | 'noLower'
  | 'noUpper'
  | 'noDigit'
  | 'noSymbol';

export const collectPasswordFailures = (password: string): PasswordFailureKey[] => {
  const failures: PasswordFailureKey[] = [];
  if (password.length < 8) failures.push('tooShort');
  if (!/[a-z]/.test(password)) failures.push('noLower');
  if (!/[A-Z]/.test(password)) failures.push('noUpper');
  if (!/\d/.test(password)) failures.push('noDigit');
  if (!/[^A-Za-z0-9]/.test(password)) failures.push('noSymbol');
  return failures;
};

export const getPasswordStrength = (password: string): PasswordStrength => {
  if (!password) return 'empty';
  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecial = /\W/.test(password);
  const validLength = password.length > 7;
  if (hasUpper && hasLower && hasDigit && hasSpecial && validLength) return 'strong';
  if (hasUpper || hasLower || hasDigit || hasSpecial || validLength) return 'weak';
  return 'empty';
};
